import { Line } from 'react-chartjs-2';
import { Chart as ChartJS, LineElement, CategoryScale, LinearScale, PointElement, Tooltip, Legend } from 'chart.js';
ChartJS.register( LineElement, CategoryScale, LinearScale, PointElement, Tooltip, Legend );

const LineChart = ({ chartData, xKey, yKey }) => {
  if (!chartData || chartData.length === 0) {
    return <div>No data provided for the line chart.</div>;
  }

  const labels = chartData.data.map(item => item[xKey]);
  const datasets = [
  {
    label: yKey,  // you decide the label
    data: chartData.data.map(item => item[yKey]),
    borderColor: "#1e4263",
    tension: 0.4,
  },
];
  
  const data = { labels, datasets, };

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: { position: 'bottom' },
      tooltip: {
        callbacks: {
          label: (context) => `${context.dataset.label}: ${context.formattedValue}`,
        },
      },
    },
  };

  return (
    <div style={{ width: '100%', height: '100%' }}>
      <Line data={data} options={options} />
    </div>
  );
};

export default LineChart;
